import HTTPClient from './http-client';

const blob = { responseType: 'arraybuffer' }

const END_POINT = '/post';

const loadReports = async () => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}s/relatorios_infohidro`,
  );
}

const loadFile = async ({post_id,content_id,file_id}) =>{
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}/file?content_id=${content_id}&file_id=${file_id}&post_id=${post_id}`,
    blob
  );
}

const loadFiles = async ({content_id,file_ids}) =>{
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}s/files?content_id=${content_id}&file_ids=${file_ids}`,
    blob
  );
}

export {
  loadReports,
  loadFile,
  loadFiles,
}
